export default __webpack_public_path__ + "static/media/helmetTwo.eaffc7f8.png";